var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 64,
    viewBox: "0 0 55 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Favicon_Copy",
    "data-name": "Favicon Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star-2",
    "data-name": "Star",
    d: "M0,25.423-54.255,13.653-63.486,0l5.85,25.423Z",
    transform: "translate(55 64) rotate(90)",
    fill: "rgba(0,0,0,0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star-3",
    "data-name": "Star",
    d: "M0,25.423-54.255,13.653-63.486,0l5.85,25.423Z",
    transform: "translate(55 64) rotate(90)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Star-4",
    "data-name": "Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star-5",
    "data-name": "Star",
    d: "M0,26.2l54.578-12.13L63.864,0,57.979,26.2Z",
    transform: "translate(0 63.864) rotate(-90)",
    fill: "rgba(0,0,0,0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star-6",
    "data-name": "Star",
    d: "M0,26.2l54.578-12.13L63.864,0,57.979,26.2Z",
    transform: "translate(0 63.864) rotate(-90)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainlogo);
export default __webpack_public_path__ + "static/media/mainlogo.f2687d358089f94697d70d2e5f0e2f6a.svg";
export { ForwardRef as ReactComponent };